export default class SupportSearch {
  constructor(element) {
    this.el = element;

    this.siteName = this.el.dataset.site;

    this.searchButton = this.el.querySelector(".support-search-button");
    this.searchField = this.el.querySelector("#support-search");
    this.resultList = this.el.querySelector(".search-result");
    this.resultText = this.el.querySelector(".result");
    this.pagingContainer = this.el.querySelector(".paging");

    this.generateResult = this.generateResult.bind(this);
    this.searchSite = this.searchSite.bind(this);
    this.pagePerView =
      this.el.dataset.paging != null ? this.el.dataset.paging : 10;
    this.generatePager = this.generatePager.bind(this);
    this.usePager = this.usePager.bind(this);
    this.buildResult = this.buildResult.bind(this);

    this.init();
  }

  init() {
    const params = new URLSearchParams(location.search);
    if (params.get("query") != null) {
      this.searchSite(params.get("query"));
      if (this.searchField.value != params.get("query")) {
        this.searchField.value = params.get("query");
      }
    }

    this.searchButton.addEventListener("click", event => {
      if (this.searchField.value.length > 0) {
        this.searchSite(this.searchField.value);
      } else {
        this.searchSite("");
      }
    });

    this.searchField.addEventListener("keyup", event => {
      if (event.keyCode === 13) {
        this.searchSite(this.searchField.value);
      }
    });
  }

  generateResult() {
    const params = new URLSearchParams(location.search);
    let pagingParameter =
      params.get("page") != null
        ? this.pagePerView * (Math.trunc(params.get("page")) - 1)
        : 0;

    let searchQuery = params.get("query") != null ? params.get("query") : "";

    let data = {
      types: ["supportArticle"],
      searchText: searchQuery,
      Take: this.pagePerView,
      Skip: pagingParameter,
      siteName: this.siteName
    };

    fetch(`/umbraco/api/search/site`, {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json"
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.buildResult(json);
        if (json.total > this.pagePerView) {
          this.generatePager(json.total);
        }
      })
      .catch(e => {});
  }

  buildResult(result) {
    const htmlTemplate = result.results
      .map(item => {
        let date = new Date(item.date);
        let formattetDate = date.toLocaleDateString("da-DK");
        return `
        <a href="${item.url}" class="cta search-result-item make-flex">
                <div class="arrow-container">
                    <svg class="svg-full-arrow">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-full-arrow"></use>
                    </svg>
                </div>
                <div class="search-result-container">
                    <p class="h3">${item.title}</p>
                    <p>${item.description}</p>
                    <p class="search-result-link color-dark-green">Læs mere</p>
                </div>
            </a>
      `;
      })
      .join("");

    this.resultList.innerHTML = "";
    this.resultList.innerHTML = htmlTemplate;

    const params = new URLSearchParams(location.search);
    var showing =
      result.total < this.pagePerView ? result.total : this.pagePerView;
    var restulttext =
      params.get("query") != null
        ? "<p>Din søgning på <span>" +
          params.get("query") +
          "</span> gav " +
          result.total +
          " resultater</p>"
        : "<p>Viser " +
          showing +
          " ud af <span>" +
          result.total +
          "</span> resultater</p>";

    this.resultText.innerHTML = restulttext;
  }

  generatePager(total) {
    const params = new URLSearchParams(location.search);
    let pagingParameter = params.get("page");
    let pages = Math.floor(total / this.pagePerView);
    let extra = total % this.pagePerView == 0 ? 0 : 1;
    let totalPages = pages + extra;

    var pagerTemplate = "";

    for (let step = 1; step <= totalPages; step++) {
      var isActive =
        pagingParameter == step || (step == 1 && pagingParameter == null)
          ? "active"
          : "";

      pagerTemplate =
        pagerTemplate +
        '<a class="paging-item ' +
        isActive +
        '" href="#" aria-label="Side ' +
        step +
        '" data-page="' +
        step +
        '">' +
        step +
        "</a>";
    }
    var startStep =
      '<a class="paging-item paging-back" data-page="0" href="#" aria-label="Forrige ' +
      this.pagePerView +
      ' sider"><svg class="svg-small-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-small-arrow-left"></use></svg></a>';
    var endStep =
      '<a class="paging-item paging-forward" data-page="999" href="#" aria-label="Næste ' +
      this.pagePerView +
      ' sider"><svg class="svg-small-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-small-arrow-right"></use></svg></a>';

    this.pagingContainer.innerHTML = startStep + pagerTemplate + endStep;
    this.pageButtons = this.el.querySelectorAll(".paging-item");
    this.pageButtons.forEach(element => {
      element.addEventListener("click", event => {
        event.preventDefault();

        this.usePager(element, totalPages);
      });
    });
  }

  usePager(button, totalPages) {
    const params = new URLSearchParams(location.search);
    var activePage = button.dataset.page;
    var pressentActiveButton = this.el.querySelector(".paging-item.active");
    var presentActivePage = pressentActiveButton.dataset.page;

    if (activePage != 0 && activePage != 999) {
      this.pageButtons.forEach(element => {
        var page = element.dataset.page;
        if (activePage == page) {
          element.classList.add("active");
          params.set("page", page);
          window.history.pushState({}, "", "?" + params.toString());

          this.generateResult();
        } else {
          element.classList.remove("active");
        }
      });
    } else if (activePage == 0 && presentActivePage != 1) {
      pressentActiveButton.classList.remove("active");
      var newActivePage = pressentActiveButton.previousSibling.classList.add(
        "active"
      );
      var newParam = Math.trunc(presentActivePage) - 1;
      params.set("page", newParam);
      window.history.pushState({}, "", "?" + params.toString());

      this.generateResult();
    } else if (activePage == 999 && presentActivePage != totalPages) {
      pressentActiveButton.classList.remove("active");
      pressentActiveButton.nextSibling.classList.add("active");
      var newParam = Math.trunc(presentActivePage) + 1;
      params.set("page", newParam);
      window.history.pushState({}, "", "?" + params.toString());

      this.generateResult();
    } else {
      return;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }

  searchSite(query) {
    const params = new URLSearchParams(location.search);
    if (params.get("page") != null) {
      params.delete("page");
    }
    if (query.length > 0) {
      params.set("query", query);
    } else {
      params.delete("query");
    }
    window.history.pushState({}, "", "?" + params.toString());
    this.generateResult();
  }
}
